<template>
    <v-dialog v-model="dialog" max-width="400">
        <template v-slot:activator="{ on }">
            <v-btn v-if="fab" fab bottom left dark fixed color="indigo"  v-on="on">
                <v-icon>{{icons.upload}}</v-icon>
            </v-btn>
            <v-btn
                    v-else
                    color="awesome"
                    dark
                    v-on="on"
            >
                <v-icon>{{icons.upload}}</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                File Uploader
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog=false"><v-icon>{{icons.close}}</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
                <v-row v-if="previews && !crop" justify="center" align="center">
                    <v-col cols="6" sm="4" md="4" lg="4"  v-for="(p,i) in previews" :key="p">
                        <div :style="`background-image: url(${p});height:100px;background-position: center;background-size: cover;background-repeat: no-repeat; `">
                            <v-icon v-if="progress[i]===100"  color="info" class="mt-2 ml-2 ol">{{icons.thumbsup}}</v-icon>
                        </div>
                        <div v-if="progress[i]<100" >
                            <v-progress-linear height="6" v-model="progress[i]" ></v-progress-linear>
                        </div>

                    </v-col>
                </v-row>
                <v-row v-if="previews[0] && crop">
                    <v-col>
                        <vue-cropper
                                v-if="!cropImg"
                                ref="cropper"
                                :src="previews[0]"
                                :aspectRatio="1"
                        >
                        </vue-cropper>
                        <v-img v-else :src=" cropImg" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <form ref="form">
                            <v-file-input
                               hint="Select Files"
                               outlined
                               accept="image/*"
                               :disabled="disabled"
                               chips
                               show-size
                               :multiple="!limitone"
                               ref="files"
                               @change="readfile($event)"
                            />
                        </form>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="awesome" dark :disabled="!finished"  v-if="crop" @click="cropImage()">Save</v-btn>
                <v-btn color="awesome"
                       dark
                       large
                       @click="Upload()"
                       v-if="showupload && !crop"
                       :disabled="!finished"
                >
                    <v-icon large>{{icons.upload}}</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
  import VueCropper from 'vue-cropperjs';
  import 'cropperjs/dist/cropper.css';
    import {
      mapState,
      mapActions
    } from 'vuex'
    import AWS from 'aws-sdk'
    export default {
      props: ['fab','limitone','crop'],
      components: { VueCropper },
      data: () => ({
        dialog: false,
        disabled: false,
        progress: [],
        filestoupload: undefined,
        previews: [],
        uploading:false,
        showupload:false,
        emitkeys: [],
        cropImg:false
      }),
      computed:{
        ...mapState(['idpool','userpool','org','icons']),
        finished(){
          return this.progress.every(f=>{return f===100})
        }
      },
      watch:{
        dialog(n,o){
          if(!n){
            this.$refs.files.reset()
          }
        },
        finished(n,o){
          if(n){
            this.disabled=false
            this.showupload=false
            this.$emit('newfiles',this.emitkeys)
            this.emitkeys = []
            this.dialog = false
          }
        }
      },
      methods: {
        ...mapActions(['cognito']),
        readfile(event) {
          this.previews = []
          this.filestoupload = event.length===0?undefined:event
          this.showupload = event.length===0?false:true
          let em = this;
          event.forEach((file,i) => {
            em.previewFile(file,i)
          })
        },
        previewFile(file,i) {
          const reader = new FileReader();
          let em = this;
          reader.addEventListener("load", function () {
            em.previews.push(reader.result)
            em.progress[i] = 0
          }, false);
          reader.readAsDataURL(file);
        },
        async Upload() {
          //SET THIS STUFF GLOBALLY, MAYBE...
          let em = this;
          this.disabled=true
          let session = await this.$store.dispatch('cognito/fetchSession')
          let idKey = 'cognito-idp.us-west-2.amazonaws.com/' + this.userpool
          AWS.config.region = 'us-west-2';
          AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: this.$store.state.idpool,
            Logins: {
              [idKey]: session.idToken.jwtToken
            }
          });
          em.filestoupload.forEach((file,i)=>{
            AWS.config.credentials.get(function (err) {
              if (err){
                this.disabled=false
                return console.log(err)
              }
              let str = file.name
              let f = str.split('.')
              let g = str.split('.')
              f.splice(-1,1)
              let f2 = f.join('')
              let filekey = f2+new Date().getTime()+'.'+g.pop()
              em.emitkeys.push({Key:filekey,Size:file.size})
              var ud = new AWS.S3.ManagedUpload({
                partSize: 10 * 1024 * 1024, queueSize: 1,
                computeChecksums: true,
                params: {
                  Bucket: 'orgbucket-'+em.org.partkey,
                  Key: filekey,
                  Body: file,
                  ACL: 'public-read'
                },
                tags: [{Key:'uploadedby',Value:session.accessToken.payload.sub}]
              });
              ud.on('httpUploadProgress', (event) => {
                let t = event.loaded * 100 / event.total
                em.$set(em.progress,i,t)
              });
              ud.send(function (err, data) {
                if(err) return console.log(err)
                window.localStorage.setItem('filetosend', data.Location)
              })
            })
          })
        },
        clearAll(){
          this.filestoupload = undefined
        },
        cropImage() {
          // get image data for post processing, e.g. upload or setting image src
          this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
        },
      }
    }
</script>

<style>
    .ol{
        color: black;
        -webkit-text-fill-color: white; /* Will override color (regardless of order) */
        -webkit-text-stroke-width: 1px;
        -webkit-text-stroke-color: black;
    }
</style>
